import React from 'react';

function Footer() {
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || "jainmatrimony22@gmail.com";

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-800 shadow-lg border-t border-gray-700">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center h-16">
          <div className="font-medium text-white text-sm tracking-tight">
            Contact us: <a 
              href={`mailto:${contactEmail}`} 
              className="text-indigo-300 hover:text-indigo-200 underline transition-colors"
              aria-label={`Send email to ${contactEmail}`}
            >
              {contactEmail}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;

